/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useEvent } from '@api/hooks';
import { Typography } from '@atoms';
import { EventField, ModeSelect, TextField, ContentModuleModal } from '@molecules';
import MediaField from '@organisms/MediaField';

import Form from '../Form';

import { FORM_FIELD, FORM_FIELDS, MODE, MODES, INITIAL_VALUES } from './constants';
import Item from './Item';
import s from './styles.module.less';

const NextEvent = ({ visible, onSubmit, hide, previewImg, onDelete, initialValues: data = INITIAL_VALUES, errors }) => {
  const [form] = Form.useForm(FORM_FIELDS);
  const initialValues = React.useMemo(() => form.deserialize(data), [data, form]);
  const defaultMode = initialValues?.eventId ? MODE.EXISTING.value : MODE.MANUAL.value;
  const [mode, setMode] = React.useState(defaultMode);

  const { event } = useEvent(initialValues?.eventId);

  React.useEffect(() => {
    if (event?.id) {
      form.setFieldsValue({ [FORM_FIELD.EVENT.name]: event });
    }
  }, [event, form]);

  const handleFinish = React.useCallback(
    (values) => {
      onSubmit(values);
      form.resetFields();
      hide();
    },
    [form, hide, onSubmit],
  );

  const handleCancel = () => {
    form.resetFields();
    hide();
  };

  return (
    <ContentModuleModal
      visible={visible}
      title="Next Event"
      subtitle="Choose an upcoming event to feature on the page"
      okText={onDelete ? 'SAVE CHANGES' : 'ADD NEXT EVENT'}
      onCancel={handleCancel}
      onSubmit={form.submit}
      onDelete={onDelete}
      heroImageSrc={previewImg}
      errors={errors}
    >
      <Form
        form={form}
        hideRequiredMark
        layout="vertical"
        wrapperCol={{ span: 24 }}
        initialValues={initialValues}
        onSerializedFinish={handleFinish}
      >
        <ModeSelect defaultMode={defaultMode} onSelect={setMode} modes={MODES} />
        {mode === MODE.MANUAL.value ? (
          <>
            <MediaField {...FORM_FIELD.EVENT_IMAGE} />
            <TextField {...FORM_FIELD.EVENT_TOP_TITLE} className={s.smallBottomMargin} />
            <TextField {...FORM_FIELD.EVENT_BOTTOM_TITLE} />
            <TextField {...FORM_FIELD.EVENT_SUBTITLE} />
            <TextField {...FORM_FIELD.EVENT_URL} />
          </>
        ) : (
          <EventField {...FORM_FIELD.EVENT} extra={null} wrapperCol={{ span: 24 }} />
        )}
        <Typography.Title level={3} note="(optional)">
          Feature Links
        </Typography.Title>
        <Form.List {...FORM_FIELD.EVENT_FEATURE_LINKS}>
          {(fields) => {
            return fields.map((record, idx) => (
              <div key={`record_idx_${idx}`} className={s.featureLink}>
                <TextField {...FORM_FIELD.EVENT_FEATURE_LINK_NAME(idx)} className={s.smallBottomMargin} />
                <TextField {...FORM_FIELD.EVENT_FEATURE_LINK_URL(idx)} />
              </div>
            ));
          }}
        </Form.List>
      </Form>
    </ContentModuleModal>
  );
};

NextEvent.Item = Item;

export default NextEvent;
